import ConfigJSON from '../../config.json';
import type { SessionCacheType } from './types';

export function createCache(): SessionCacheType {
  return {
    clear(): void {
      const preffix = createKey('');
      Array(sessionStorage.length)
        .fill(0)
        .map((v, index) => {
          const key = sessionStorage.key(index);
          return key && key.indexOf(preffix) >= 0 ? key : undefined;
        })
        .forEach(key => {
          key && sessionStorage.removeItem(key);
        });
    },
    remove(key: string): void {
      sessionStorage.removeItem(createKey(key));
    },
    get<T>(key: string): T | undefined {
      const cache = sessionStorage.getItem(createKey(key));
      return cache == null ? undefined : (JSON.parse(cache) as T);
    },
    set<T>(key: string, value: T): void {
      sessionStorage.setItem(createKey(key), JSON.stringify(value));
    },
  };
}

function createKey(key: string) {
  return `${ConfigJSON.appName}.SessionCache.${key}`;
}
